const japaneseCharacters = /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]/g
const englishCharacters = /[a-zA-Z]/g

export const calculateLanguagePercentage = (sentence: string) => {
  const japaneseCount = sentence.match(japaneseCharacters)?.length ?? 0
  const englishCount = sentence.match(englishCharacters)?.length ?? 0

  const totalCharacters = japaneseCount + englishCount
  if (totalCharacters === 0) return { japanesePercentage: 0, englishPercentage: 0 }

  return {
    japanesePercentage: (japaneseCount / totalCharacters) * 100,
    englishPercentage: (englishCount / totalCharacters) * 100,
  }
}

/** Extract the `[langCode]`-tagged segment from a string like `"[en] Title [ja] タイトル"`. */
export const extractContent = (input: string, langCode: string) => {
  const regex = new RegExp(`\\[${langCode}\\]([^\\[]+)`, "i")
  const match = input?.match(regex)
  return match ? match[1].trim() : ""
}

/** Replace newline characters with HTML `<br>` tags for email/HTML display. */
export const convertBreak = (value: string): string => value.replace(/\n/g, "<br>")

/** Format a byte count as a human-readable megabyte string, e.g. `"1.23mb"`. */
export const formatFileSizeMb = (bytes: number): string => (bytes / (1024 * 1024)).toFixed(2) + "mb"
